import { DeviceIcon } from '@2n/design-system';
import { SvgIcon } from '@mui/material';
import Badge from '@mui/material/Badge';
import { ReactComponent as ThirdPartyAxisSIP } from '../../assets/ThirdPartyAxisSIP.svg';
import { palette } from '../../theme';
import { devicesWithSvgIcon, getIcon } from './deviceTypeHelpers';
import { Icon } from './Icon';

const styles = {
  badgeError: {
    '& .MuiBadge-badge': {
      backgroundColor: 'error.main',
    },
  },
  badgeWarning: {
    '& .MuiBadge-badge': {
      backgroundColor: 'warning.main',
    },
  },
};

export interface IDeviceTypeIconProps {
  deviceType: string;
  outline?: boolean;
  outlineColor?: string;
  showAvatar?: boolean;
  showErrorBadge?: boolean;
  showWarningBadge?: boolean;
  size?: 24 | 32 | 40 | 48 | 64 | 80 | 96 | 144 | 192;
  type?: string;
}

export function DeviceTypeIcon({
  deviceType,
  outline = true,
  outlineColor = palette.secondary.main,
  showAvatar,
  showErrorBadge,
  showWarningBadge,
  size = outline ? 24 : 32,
  type,
}: IDeviceTypeIconProps) {
  const svgIcon = type !== undefined ? devicesWithSvgIcon[type] : undefined;
  const transformedDeviceType = getIcon(deviceType, type);

  return (
    <Badge
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
      invisible={!showErrorBadge && !showWarningBadge}
      overlap="circular"
      sx={{
        ...(showWarningBadge && styles.badgeWarning),
        ...(showErrorBadge && styles.badgeError),
      }}
      variant="dot"
    >
      <Icon showAvatar={showAvatar}>
        {svgIcon !== undefined ? (
          <SvgIcon component={ThirdPartyAxisSIP} color="inherit" />
        ) : (
          <DeviceIcon
            id={transformedDeviceType}
            noShadow={true}
            outline={outline}
            outlineColor={outlineColor}
            size={size}
          />
        )}
      </Icon>
    </Badge>
  );
}
